import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  container: {
    height: theme.spacing(5),
    margin: 0,
    borderBottom: `1px solid ${theme.palette.brand.greyWhite}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  header: {
    color: theme.palette.brand.greenDark,
    fontWeight: 'bold',
  },
  subHeader: {
    marginTop: theme.spacing(5),
  },
}));

export default function Header(props) {
  const classes = useStyles();
  const { header } = props;
  return (
    <div className={classes.container}>
      <Typography variant="h6" align="center" className={classes.header}>
        {header}
      </Typography>
    </div>
  );
}
